export default {
  max: '$2a$10$8PeTpu9BQsDbNFXV/PiwvuIn.kpvPSW9YvgCr2PjeSzoHraB9oDRG',
  cs: '$2a$10$4kDCTSI5q1FHYH3LHwyMH.c/ASBdtiiSfP3plkdKJwdUrxjOYSUO6',
};
